
/**
 * @fileOverview ComplianceBanner module definition
 * @author a3xs8zz
 * @modified 6/23/2015
 **/

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;


    define('kungfu/ComplianceBanner/ComplianceBanner',['require', 'jquery', 'lib/Util', 'kungfu/ComplianceBanner/ComplianceRules'], function (require) {
        var $ = require('jquery'),
            util = require('lib/Util'),
            ComplianceRules = new require('kungfu/ComplianceBanner/ComplianceRules');

        var ComplianceBanner = function(){
            $debug('**** Compliance Banner Set Up Started **** ', 'compBanner'); //syntax: $debug(message, urlParam);
        	this.container = $('<div class="MMM--complianceBanner MMM--modalContainer js-complianceBanner"></div>');
        	this.modalHeader = $('<div class="MMM--modalContainer-header"></div>');
            this.innerContent = $('<div class="MMM--modalContainer-inner"></div>');
        	this.closeBtn = $('<a class="MMM--modalContainer-header-closeLink js-closeLink" href="#" target="_self"><span class="MMM--icn MMM--icn_close MMM--closeTrigger"></span></a>');
            this.overlay = $('<div class="MMM--themeOverlay MMM--themeOverlayGrey js-overlay"></div>');
        	this.settings = new ComplianceRules().settings;
            this.campaign = 'default';
            this.cookieVal = '';
            this.blurClass = 'MMM--isBlurred';

        	this.init();
        }

        /*  The Compliance Banner is for sites or products that require
            the user to acknowledge a notification or verify identify
            in a non-secured fashion. A modal will appear that contains
            externally-hosted content (most often through WCM).  The
            content should include an "Accept" (wording can vary)
            button and optionally a "Decline" button.

            In most cases, the user must accept in order to continue
            browsing the page or site.  In some cases, declining will
            send the user to another page.

            This plugin is meant to key off of site or page-level
            configurations (through window.SETTINGS variables), or
            from SNAPS action attributes.

            Different products or sites/pages can have "campaigns" that
            will determine which settings are used.

            For example, the healthcare campaign is "FUZE Health Care
            Compliance".
        */

        ComplianceBanner.prototype.init = function(){
            var self = this;

            // If there is no path for modal content do not fire any modules
            if(!!this.settings.PATH){
                if(!!this.settings.NAME){
                    this.campaign = this.settings.NAME;
                    this.cookieVal = $getCookie('mmmCompliance.' + this.campaign);
                }

                if(this.settings.PATH.indexOf('{loc}') > -1){
                    this.settings.PATH = this.settings.PATH.replace('{loc}', window.SETTINGS.LOCALE);
                    $debug('Localizing content path: ' + this.settings.PATH, 'compBanner');
                }

                // First check to see if this is an authentication banner
                if(this.settings.AUTHENTICATE){
                    // If the user ID is not in the SETTINGS object
                    if(!window.SETTINGS.uID || window.SETTINGS.uID === '' || window.SETTINGS.uID == 'null'){
                         $debug('User is unauthenticated, firing register/login modal...', 'compBanner');
                        // Build and show the modal
                        this.buildModal();
                    } else{
                         $debug('User is authenticated, skip firing modal...', 'compBanner');
                    }
                }
                // Otherwise this is a standard compliance banner with cookies
                else {
                    // If the user has not accepted, we need to show the banner
                    if(this.cookieVal !== 'accept'){
                        $debug('User has not accepted compliance message: ' + this.cookieVal, 'compBanner');
                        // Build and show the modal
                        this.buildModal();
                    } else{
                         $debug('User has accepted compliance message, skip firing modal...', 'compBanner');
                    }
                }
            }

			return this;
        }

		ComplianceBanner.prototype.setupHandlers = function($bannerContent){
			var self = this;

            // Accept handler
            $bannerContent.find('.js-complianceAccept').on('click', function(event){
                event.preventDefault();
                self.complianceAccept();
            });

            // Decline handler
            $bannerContent.find('.js-complianceDecline').on('click', function(event){
                event.preventDefault();
                self.complianceDecline();
            });

            // If there's a close button, treat it that same as accepting
            if(this.settings.CLOSE){
                $bannerContent.find('.js-closeLink').on('click', function(event){
                    event.preventDefault();
                    self.complianceAccept();
                });
            }

            // Authentication handler
            $bannerContent.find('.js-loginLink').on('click', function(event){
                event.preventDefault();

                var newUrl = location.href;

                if(newUrl.indexOf('/portal/') > -1){
                    newUrl = newUrl.replace('/portal/', '/myportal');
                }
                if(newUrl.indexOf('/3M/') > -1){
                    newUrl = newUrl.replace('/3M/', '/my3M/');
                }

                location.href = newUrl;
            })

			return this;
		}

        ComplianceBanner.prototype.buildModal = function(){
            var self = this;

            // Assemble the modal
            this.container.append(this.modalHeader);
            this.container.append(this.innerContent);

            // Only include the close link if it is enabled in the settings
            if(this.settings.CLOSE){
               $debug('Adding close link to banner based on settings...', 'compBanner');

               this.modalHeader.append(this.closeBtn);
            }

            $debug('Compliance Banner content path: ' + this.settings.PATH, 'compBanner');

            $.ajax({
                url: '/wps/wcm/connect' + this.settings.PATH,
                success: function(response){
                    self.appendBanner(response, self);
                }
            });
        }

		ComplianceBanner.prototype.appendBanner = function(response, self){
            $debug('Appending Compliance Banner Content to body...', 'compBanner');

            // Append the banner contents to the container, which is then appended to the body, unhidden and centered
            self.innerContent.append(response);
            $('#js-bodyWrapper').before(self.container.show());
            self.container.css({top: (window.innerHeight-self.container.outerHeight())/2});
            $('body').append(this.overlay);
            
            // If the BLUE option is enabled, apply a blur class to the body container
            if(this.settings.BLUR){
                $('#js-bodyWrapper').addClass(this.blurClass);
            }

            // Need to initialize the buttons and fire event handlers for the banner buttons
            updateMMMButtons(self.container.find('.MMM--btn'));
            self.setupHandlers(self.container);

            return self;
		}

        ComplianceBanner.prototype.complianceAccept = function(){
            var expiration = null;
            
            $debug('User has accepted the compliance agreement...', 'compBanner');
            
            if(typeof this.settings.EXPIRATION === 'number'){
                $debug('Cookie expiration override found, setting cookie expiration to ' + this.settings.EXPIRATION + ' days...', 'compBanner');
                
                expiration = this.settings.EXPIRATION;
            }

            // Set the cookie to accept
            $setCookie('mmmCompliance.' + this.campaign, 'accept', 1, expiration);

            // Close the modal so the user can browse normally
            this.closeBanner();

            return this;
        }

        ComplianceBanner.prototype.complianceDecline = function(){
            // Don't set a cookie for decline
            //$setCookie('complianceBanner', 'decline', 1, 'null');

            if(!!this.settings.REDIRECT){
                $debug('User has declined the compliance agreement, redirect URL found: ' + this.settings.REDIRECT, 'compBanner');

                this.redirect();
            } else{
                $debug('User has declined the compliance agreement, no redirect URL found, closing compliance window', 'compBanner');

                // Close the modal so the user can browse normally
                this.closeBanner();
            }


            return this;
        }
        ComplianceBanner.prototype.closeBanner = function(){
            this.container.hide();
            this.overlay.remove();
            
            // Also remove blurring class from body container
            $('#js-bodyWrapper').removeClass(this.blurClass);

            return this;
        }

        ComplianceBanner.prototype.redirect = function(){
            var newUrl = this.settings.REDIRECT;

            if(newUrl.indexOf('/') === 0){
                newUrl = document.domain + newUrl;
            }
            window.location.href = this.settings.REDIRECT;

            return this;
        }

        return ComplianceBanner;
	});
}(MMMRequire));